export const normalizeString = string => {
  return string.normalize('NFKC')
}
